import { useMutation, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'
import { axios } from 'lib'

type Params = {
  proposalId: string
  conceptId: string
  details: string
}

export const lostProposal = async (params: Params): Promise<any> => {
  return axios.post(`/orders/proposals/${params.proposalId}/lost`, params)
}

export function useLostProposal() {
  const queryClient = useQueryClient()
  return useMutation(lostProposal, {
    onSuccess: () => {
      queryClient.invalidateQueries('orders')
      queryClient.invalidateQueries('orderActions')
      toast.success('Orçamento rejeitado com sucesso!')
    },
    onError: (error: unknown) => {
      console.error(error)
      toast.error('Não foi possível rejeitar o orçamento!')
    }
  })
}
